import React from 'react';
import {
    FieldError,
    UseFormRegister,
    Path,
    FieldValues,
} from 'react-hook-form';
import { IoAlertCircleOutline } from 'react-icons/io5';

interface TextAreaProps<TFormData extends FieldValues> {
    name: Path<TFormData>;
    placeholder?: string;
    label: string;
    register: UseFormRegister<TFormData>;
    error?: FieldError;
    labelStyle?: string;
    textareaStyle?: string;
    errorStyle?: string;
}

const CustomTextArea = <TFormData extends FieldValues>({
    name,
    placeholder,
    label,
    register,
    error,
    labelStyle,
    textareaStyle,
    errorStyle,
}: TextAreaProps<TFormData>) => {
    return (
        <div className="w-full">
            {label ? (
                <label
                    className={`${
                        labelStyle ? labelStyle : ''
                    } px-2 bg-white text-base text-lime-800`}
                    htmlFor={String(name)}
                >
                    {label}
                </label>
            ) : (
                ''
            )}

            <textarea
                placeholder={placeholder}
                {...register(name)}
                className={`${textareaStyle ? textareaStyle : ''} rounded-md w-full`}
                autoComplete="off"
            ></textarea>
            {error && (
                <span
                    className={`${
                        errorStyle ? errorStyle : ''
                    } text-xs text-red-400`}
                >
                    <IoAlertCircleOutline className="inline mr-1" />{' '}
                    {error.message}
                </span>
            )}
        </div>
    );
};

export default CustomTextArea;
